export const SEAWEEDS_ROOT_PATH = '';

export const adminNavigationItems = [
  { id: 'overview', label: 'Dashboard', path: '/admin/dashboard', role: 'admin' },
  {
    id: 'daily-entries',
    label: 'Daily Entries',
    path: '/admin/daily-entries',
    role: 'admin',
  },
  {
    id: 'sales-order',
    label: 'Sales Order',
    path: '/admin/sales-order',
    role: 'admin',
  },
  {
    id: 'purchase-order',
    label: 'Purchase Order',
    path: '/admin/purchase-order',
    role: 'admin',
  },
  { id: 'dumping', label: 'Dumping', path: '/admin/dumping', role: 'admin' },
  { id: 'inventory', label: 'Inventory', path: '/admin/inventory', role: 'admin' },
  {
    id: 'releasing',
    label: 'Releasing',
    path: '/admin/releasing',
    role: 'admin',
  },
  {
    id: 'sales-analytics',
    label: 'Release Analytics',
    path: '/admin/sales-analytics',
    role: 'admin',
  },
  {
    id: 'supplier',
    label: 'Supplier',
    path: '/admin/supplier',
    role: 'admin',
    children: [
      {
        id: 'cash-advance',
        label: 'Cash Advance',
        path: '/admin/cash-advance',
        role: 'admin',
      },
      {
        id: 'supplier-savings',
        label: 'Supplier Savings',
        path: '/admin/supplier-savings',
        role: 'admin',
      },
      {
        id: 'manage-suppliers',
        label: 'Manage Suppliers',
        path: '/admin/supplier',
        role: 'admin',
      },
    ],
  },
  {
    id: 'lansa',
    label: 'Master Data',
    path: '/admin/lansa',
    role: 'admin',
    children: [
      { id: 'lansa-name', label: 'Lansa Name', path: '/admin/lansa?tab=lansa-name' },
      {
        id: 'seaweed-type',
        label: 'Seaweed Types',
        path: '/admin/lansa?tab=seaweed-type',
      },
      {
        id: 'warehouse-location',
        label: 'Warehouse Location',
        path: '/admin/lansa?tab=warehouse-location',
      },
      {
        id: 'tare-amount-fee',
        label: 'Tare Amount Fee',
        path: '/admin/lansa?tab=tare-amount-fee',
      },
      {
        id: 'savings-per-kilo',
        label: 'Savings per Kilo',
        path: '/admin/lansa?tab=savings-per-kilo',
      },
    ],
  },
  {
    id: 'expenses',
    label: 'Expenses',
    path: '/admin/expenses',
    role: 'admin',
  },
  { id: 'customer', label: 'Customer', path: '/admin/customer', role: 'admin' },
];

export const staffNavigationItems = [
  { id: 'overview', label: 'Dashboard', path: '/staff/dashboard', role: 'staff' },
  {
    id: 'receiving',
    label: 'Receiving',
    path: '/staff/receiving',
    role: 'staff',
  },
  {
    id: 'expenses',
    label: 'Expenses',
    path: '/staff/expenses',
    role: 'staff',
  },
];

export const adminCustomNavigationItems = [
  { id: 'overview', label: 'Dashboard', path: '/admin/dashboard', role: 'admin' },
  {
    id: 'daily-entries',
    label: 'Daily Entries',
    path: '/admin/daily-entries',
    role: 'admin',
  },
  {
    id: 'initial-summary-po',
    label: 'Initial Summary P.O.',
    path: '/admin/initial-summary-po',
    role: 'admin',
  },
  {
    id: 'supplier-balancing',
    label: 'Supplier Balancing',
    path: '/admin/supplier-balancing',
    role: 'admin',
  },
  {
    id: 'sales-analytics',
    label: 'Release Analytics',
    path: '/admin/sales-analytics',
    role: 'admin',
  },
];

export const accountantNavigationItems = [
  {
    id: 'releasing',
    label: 'Releasing',
    path: '/admin/releasing',
    role: 'admin',
  },
  {
    id: 'expenses',
    label: 'Expenses',
    path: '/admin/expenses',
    role: 'admin',
  },
];
export const defaultAccountantNavigationItems = accountantNavigationItems;

export const roleEntryRoutes = [
  {
    id: 'admin-root',
    label: 'Seaweeds',
    path: SEAWEEDS_ROOT_PATH,
    role: 'admin',
    redirectTo: '/admin/dashboard',
  },
  {
    id: 'admin-entry',
    label: 'Admin',
    path: '/admin',
    role: 'admin',
    redirectTo: '/admin/dashboard',
  },
  {
    id: 'staff-entry',
    label: 'Staff',
    path: '/staff',
    role: 'staff',
    redirectTo: '/staff/dashboard',
  },
];

export const allNavigationItems = flattenNavigationItems([
  ...adminNavigationItems,
  ...adminCustomNavigationItems,
  ...accountantNavigationItems,
  ...staffNavigationItems,
]);
export const allRoutes = [...roleEntryRoutes, ...allNavigationItems];

export const defaultRoute = roleEntryRoutes[0];

export function findRouteByPath(pathname) {
  const normalizedPath = normalizeRoutePath(pathname);

  return allRoutes.find((item) => item.path === normalizedPath) || defaultRoute;
}

export function normalizeRoutePath(pathname) {
  if (!pathname || pathname === '/') {
    return SEAWEEDS_ROOT_PATH;
  }

  if (pathname.length > 1 && pathname.endsWith('/')) {
    return pathname.slice(0, -1);
  }

  return pathname;
}

export function getNavigationItemsByRole(role, allowedAccountantTabIds = null) {
  if (role === 'admin-custom') {
    return adminCustomNavigationItems;
  }

  if (role === 'accountant') {
    return filterNavigationItemsByIds(
      adminNavigationItems,
      Array.isArray(allowedAccountantTabIds) ? allowedAccountantTabIds : ['releasing', 'expenses']
    );
  }

  if (role === 'staff') {
    return staffNavigationItems;
  }

  return adminNavigationItems;
}

export function getAccountantEntryPath(allowedAccountantTabIds = null) {
  const items = getNavigationItemsByRole('accountant', allowedAccountantTabIds);
  const firstItem = findFirstNavigationTarget(items);

  return firstItem?.path || '/admin/releasing';
}

function filterNavigationItemsByIds(items, allowedIds) {
  const allowedIdSet = new Set(allowedIds);

  return items
    .map((item) => {
      const children = item.children
        ? item.children.filter((child) => allowedIdSet.has(child.id))
        : [];
      const isAllowed = allowedIdSet.has(item.id);

      if (!isAllowed && !children.length) {
        return null;
      }

      return {
        ...item,
        children: children.length ? children : undefined,
      };
    })
    .filter(Boolean);
}

function findFirstNavigationTarget(items) {
  for (const item of items) {
    if (item.path) {
      return item;
    }

    const childTarget = findFirstNavigationTarget(item.children || []);

    if (childTarget) {
      return childTarget;
    }
  }

  return null;
}

function flattenNavigationItems(items) {
  return items.flatMap((item) => [
    item,
    ...(item.children || []).map((child) => ({
      ...child,
      role: child.role || item.role,
    })),
  ]);
}
